module.exports = __webpack_public_path__ + "img/s2.f5f8cf48.jpg";